import { IColumnHeader, Input, TableRow } from '@aon/aon-tws-common-ui';
import React from 'react';
import { useAppDispatch } from '../../../../appStore';
import { IAudience, IDistributionContact } from '../../../../models';
import { updatePendingParticipants } from '../../../../store/PendingParticipantsSlice';

export interface IAudienceParticipantsTableRow {
	columns: IColumnHeader[];
	participant: IDistributionContact;
	audiences: IAudience[];
}

export const AudiencesParticipantsTableRow = ({ columns, participant, audiences }: IAudienceParticipantsTableRow) => {
	const audienceName = audiences.find((a) => a.audienceId === participant.audienceId)?.audienceName;
	const dispatch = useAppDispatch();

	return (
		<TableRow>
			{columns.map((column: IColumnHeader) => (
				<td key={`${participant.personId}-${column.field}`}>
					{
						{
							firstName: <>{participant.firstName}</>,
							lastName: <>{participant.lastName}</>,
							emailAddress: <>{participant.emailAddress}</>,
							audience: <>{audienceName}</>,
							accessCode: (
								<Input
									size='sm'
									placeholder='Enter Code Here'
									value={participant.accessCode}
									maxLength={40}
									onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
										dispatch(updatePendingParticipants({ contactId: participant.distributionContactId, accessCode: e.target.value }))
									}
								/>
							),
						}[column.field]
					}
				</td>
			))}
		</TableRow>
	);
};
